module.exports = __webpack_public_path__ + "img/tab1-5.291b109f.jpg";